import React from "react";
import PropTypes from "prop-types";
import classes from "classnames";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MenuItem from "@mui/material/MenuItem";

import { INDETERMINATE_VALUE } from "lib/constants";

export function indeterminateOrNullFilter({ val, defaultValue, func }) {
    if (val === INDETERMINATE_VALUE) {
        return val;
    }
    if (func) {
        return val ? func(val) : defaultValue;
    }
    return val || defaultValue;
}
indeterminateOrNullFilter.propTypes = {
    val: PropTypes.any.isRequired,
    defaultValue: PropTypes.any,
    func: PropTypes.func,
};
indeterminateOrNullFilter.defaultProps = {
    defaultValue: "",
    func: null,
};

export default function IndeterminateTextField({
    value,
    defaultValue,
    onChange,
    className,
    select,
    InputLabelProps,
    children,
    SelectProps,
    type,
    ...props
}) {
    const getIndeterminateValue = () => {
        if (select) {
            if (SelectProps.multiple) {
                return [``];
            }
            return `INDETERMINATE_SELECT_VALUE`;
        }
        return "Multiple Values";
    };

    return (
        <TextField
            {...props}
            InputLabelProps={{
                ...InputLabelProps,
                shrink: value === INDETERMINATE_VALUE || InputLabelProps.shrink,
            }}
            className={
                value === INDETERMINATE_VALUE
                    ? classes(className, "textfield-indeterminate")
                    : className
            }
            value={value === INDETERMINATE_VALUE ? getIndeterminateValue() : value}
            defaultValue={value ? undefined : defaultValue}
            type={value === INDETERMINATE_VALUE ? "text" : type}
            select={select}
            onChange={onChange}
            SelectProps={
                value === INDETERMINATE_VALUE
                    ? {
                          renderValue: () => (
                              <MenuItem value={getIndeterminateValue()}>Multiple Values</MenuItem>
                          ),
                      }
                    : SelectProps
            }
            onFocus={(e) => {
                // simulate a placeholder behavior, because I can't
                // get an actual placeholder to render with a consistent
                // style as a select value
                if (value === INDETERMINATE_VALUE) {
                    if (SelectProps.multiple) {
                        e.target.value = [];
                    } else {
                        e.target.value = "";
                    }
                    onChange(e);
                }
            }}
        >
            {select && value === INDETERMINATE_VALUE && (
                <MenuItem value={getIndeterminateValue()}>Multiple Values</MenuItem>
            )}
            {children}
        </TextField>
    );
}

IndeterminateTextField.propTypes = {
    value: PropTypes.any,
    defaultValue: PropTypes.any,
    className: PropTypes.any,
    select: PropTypes.bool,
    InputLabelProps: PropTypes.object,
    onChange: PropTypes.func,
    SelectProps: PropTypes.object,
    type: PropTypes.any,
};

IndeterminateTextField.defaultProps = {
    value: undefined,
    defaultValue: undefined,
    className: null,
    select: null,
    InputLabelProps: {},
    onChange: null,
    SelectProps: {},
    type: null,
};

export function IndeterminateAutocomplete({ value, className, options, renderInput, ...props }) {
    const getIndeterminateValue = () => "Multiple Values";
    return (
        <Autocomplete
            {...props}
            className={
                value === INDETERMINATE_VALUE
                    ? classes(className, "textfield-indeterminate")
                    : className
            }
            options={
                value === INDETERMINATE_VALUE
                    ? [{ name: getIndeterminateValue(), id: "indeterminate" }]
                    : options
            }
            value={value === INDETERMINATE_VALUE ? null : value}
            renderInput={(params) => {
                const newParams = { ...params };
                if (value === INDETERMINATE_VALUE) {
                    newParams.inputProps.value = getIndeterminateValue();
                    newParams.InputLabelProps.shrink = true;
                }
                return renderInput(newParams);
            }}
        />
    );
}

IndeterminateAutocomplete.propTypes = {
    value: PropTypes.any,
    className: PropTypes.any,
    options: PropTypes.array,
    renderInput: PropTypes.func,
};

IndeterminateAutocomplete.defaultProps = {
    value: null,
    className: null,
    renderInput: null,
    options: [],
};
